<template>
  <div class="intelligentAgriculture-page">
    <!-- 智慧农业2.5d -->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    	<div class="main">
            <div class="top-banner">
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/zhihui2.5d/banner.png">            
            </div>
            <div class="mid-body">
                <div class="mid-body-box">
                    <h2 style="text-align: left;margin-bottom: 10px;margin-top: 80px;font-size: 38px;font-weight: 500;">物联网监测系统，精准把控生产问题</h2>

                    <div>
                        <div class="left-box">
                            <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/zhihui2.5d/index01.png">    
                         </div>
                        <div class="left-box">
                            <img style="width:20px;height:auto;margin-bottom:10px;margin-top:40px" src="../../assets/img/caseDetails/zhihui2.5d/one.png">  
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;">气象环境监测</p>
                            <p style="font-size: 16px;letter-spacing: 1px;margin-bottom:20px">农场气象实时监测，极端气象及时预报</p>
                            <p style="font-size: 16px;letter-spacing: 1px;color:#666;line-height:24px">实时监测空气温湿度、光照、降雨量、风向、大气压、气体浓度等数据，并通过设定相关报警阀值，实现
即时报警，精准控制种植环境指标。</p>
                        </div>
                    </div>
                </div>    
            </div> 

            <div class="mid-body">
                <div class="mid-body-box">
                    <div>                     
                        <div class="left-box">
                            <img style="width:20px;height:auto;margin-bottom:10px" src="../../assets/img/caseDetails/zhihui2.5d/two.png">  
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;">大棚室内环境监测</p>
                            <p style="font-size: 16px;letter-spacing: 1px;margin-bottom:20px">调节温室气候，全年满足植物生长需要</p>
                            <p style="font-size: 16px;letter-spacing: 1px;color:#666;line-height:24px">实时监测温室大棚中的温度、湿度、光照度、土壤湿度、CO2浓度等数据，并根据作物的最佳生长条件，调节温室气候使之一年四季满足植物生长需要。</p>
                        </div>
                         <div class="left-box">
                            <img style="width:100%;height:auto" src="../../assets/img/caseDetails/zhihui2.5d/index02.png">    
                         </div>
                    </div>
                </div>    
            </div>     

            <div class="mid-body">
                <div class="mid-body-box">
                    <div>
                        <div class="left-box">
                            <img style="width:100%;height:auto" src="../../assets/img/caseDetails/zhihui2.5d/index03.png">    
                         </div>
                        <div class="left-box">
                            <img style="width:20px;height:auto;margin-bottom:10px" src="../../assets/img/caseDetails/zhihui2.5d/three.png">  
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;">土壤墒情监测</p>
                            <p style="font-size: 16px;letter-spacing: 1px;margin-bottom:20px">土壤墒情精准监测，异常情况快速预警</p>
                            <p style="font-size: 16px;letter-spacing: 1px;color:#666;line-height:24px">实时监测土壤水张力、土壤温湿度、水位、溶氧量、pH值等，通过设定报警阈值，当土壤数据异常时，如湿度过高，系统自动发出预警消息提醒工作人员</p>
                        </div>
                    </div>
                </div>    
            </div>   

            <div class="mid-body">
                <div class="mid-body-box">
                    <div>                    
                        <div class="left-box">
                            <img style="width:20px;height:auto;margin-bottom:10px;margin-top:20px" src="../../assets/img/caseDetails/zhihui2.5d/four.png">  
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;">植物病虫害智能监测</p>
                            <p style="font-size: 16px;letter-spacing: 1px;margin-bottom:20px">远程掌握田间虫情，无公害诱捕杀虫</p>
                            <p style="font-size: 16px;letter-spacing: 1px;color:#666;line-height:24px">系统可实现害虫类别自动分类及计数，并自动进行无公害诱捕杀虫，减少农药的使用通过高清摄像机采集虫情图像，可远程查看田间虫情，并制定防治措施。</p>
                        </div>
                         <div class="left-box">
                            <img style="width:100%;height:auto" src="../../assets/img/caseDetails/zhihui2.5d/index04.png">    
                         </div>
                    </div>
                </div>    
            </div>  

            <div class="mid-body">
                <div class="mid-body-box">
                    <div>
                        <div class="left-box">
                            <img style="width:100%;height:auto" src="../../assets/img/caseDetails/zhihui2.5d/index05.png">    
                         </div>
                        <div class="left-box">
                            <img style="width:20px;height:auto;margin-bottom:10px;margin-top:20px" src="../../assets/img/caseDetails/zhihui2.5d/five.png">  
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;">作物长势监测</p>
                            <p style="font-size: 16px;letter-spacing: 1px;margin-bottom:20px">长期监测植物生理状态和环境因子</p>
                            <p style="font-size: 16px;letter-spacing: 1px;color:#666;line-height:24px">监测植物的实时生长状况，预测植物的生长趋势，并以实时预警形式反映植物是否受到干旱、高温等环境的不良影响。</p>
                        </div>
                    </div>
                </div>    
            </div>    

            <div class="mid-body" style=" background: rgb(246, 247, 250);    margin-bottom: 0;
    padding-top: 40px;">
                <div class="mid-body-box">
                    <h2 style="text-align: left;margin-bottom: 10px;margin-top: 80px;font-size: 38px;font-weight: 500;">自动控制设施，省时省力降低生产风险</h2>
                    <div>
                        <div class="left-box">
                            <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/zhihui2.5d/index06.png">    
                         </div>
                        <div class="left-box">
                            <img style="width:20px;height:auto;margin-bottom:10px;margin-top:40px" src="../../assets/img/caseDetails/zhihui2.5d/one.png">  
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;">智能大棚控制</p>
                            <p style="font-size: 16px;letter-spacing: 1px;margin-bottom:20px">生产环境实时监控，精准报警</p>
                            <p style="font-size: 16px;letter-spacing: 1px;color:#666;line-height:24px">无线数据采集，远程获取温室大棚内温度、湿度、光照、土壤温度、土壤湿度、二氧化碳浓度等环境信息数据。</p>
                        </div>
                    </div>
                </div>    
            </div>    
            <div class="mid-body" style=" background: rgb(246, 247, 250);    margin-bottom: 0;
    padding-top: 40px;">
                <div class="mid-body-box">
                    <div>
                        
                        <div class="left-box">
                            <img style="width:20px;height:auto;margin-bottom:10px;margin-top:40px" src="../../assets/img/caseDetails/zhihui2.5d/two.png">  
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;">智能大田控制</p>
                            <p style="font-size: 16px;letter-spacing: 1px;margin-bottom:20px">节水节肥，高质高量</p>
                            <p style="font-size: 16px;letter-spacing: 1px;color:#666;line-height:24px">通过对监测区域的土壤资源、水资源、气候信息及农情信息（苗情、墒情、虫情、灾情）等进行统一化
监控与管理。</p>
                        </div>
                        <div class="left-box">
                            <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/zhihui2.5d/index07.png">    
                         </div>
                    </div>
                </div>    
            </div>   
                <div class="mid-body" style=" background: rgb(246, 247, 250);    margin-bottom: 0;
    padding-top: 40px;">
                <div class="mid-body-box">
                    <div>
                         <div class="left-box">
                            <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/zhihui2.5d/index08.png">    
                         </div>
                        <div class="left-box">
                            <img style="width:20px;height:auto;margin-bottom:10px;margin-top:40px" src="../../assets/img/caseDetails/zhihui2.5d/three.png">  
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;">远程联动控制</p>
                            <p style="font-size: 16px;letter-spacing: 1px;margin-bottom:20px">设备设施远程控制，自动作业</p>
                            <p style="font-size: 16px;letter-spacing: 1px;color:#666">及时掌握种植现场的情况，并可根据相关参数做诊断，及时制定相关措施，为作物的高产、优质、高效、
生态、安全创造条件。</p>
                        </div>
                       
                    </div>
                </div>    
            </div>  
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style>
    .banner-title{
        width: 490px;
        height: 120px;
        position: absolute;
        top: 50%;
        right: 50%;
        margin-top: 40px;
    }
    .mid-body{
        margin-bottom: 120px;
    }
    .mid-body-box{
        width: 1200px;
        margin: auto;
        position: relative;
    }
    .left-box{
        width: 50%;
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding: 74px;
    }
    .img_index03{
        width:223px;
        height:auto;
        position:absolute;
        right: 405px;
        top: 97px;
        z-index: 2;
    }

    .img_index04{
        width: auto;
        height: 94%;
        position: absolute;
        top: 0;
        right: 65%;
        margin-top: 1%;
    }
        .img_index06{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: 97px;
        z-index: 2;
    }
        .img_index07{
    width: 223px;
    height: auto;
    position: absolute;
    left: 165px;
    top: 229px;
    z-index: 2;
    }
            .img_index09{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: -205px;
        z-index: 2;
    }
</style>